import { render, staticRenderFns } from "./NominationList.vue?vue&type=template&id=a202c6b0"
import script from "./NominationList.vue?vue&type=script&lang=js"
export * from "./NominationList.vue?vue&type=script&lang=js"
import style0 from "./NominationList.vue?vue&type=style&index=0&id=a202c6b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports